module.exports = __webpack_public_path__ + "img/SummaryBanner.1dd9df23.svg";